import React from 'react';
import { pickWithPriority } from 'Helpers/Affordances';
import useUser from 'Context/UserContext';
import PlannerAccountApplicationButtonContainer
  from 'Components/AdvisorApp/Viewport/ApexAdminPortal/OpenAccountButtonPicker/PlannerAccountApplicationButton/PlannerAccountApplicationButtonContainer';

const OpenAccountButtonPicker = () => {
  const { userResource } = useUser();

  return pickWithPriority(userResource, [

  ],
    <PlannerAccountApplicationButtonContainer />);
};

export default OpenAccountButtonPicker;
